import React from 'react';
import { Flex, Row, List } from 'antd';
import { TagOutlined, FormOutlined, TransactionOutlined } from '@ant-design/icons';
import NavItem from '../../components/nav-item';
// import SwitchShop from '../../shop/switchShop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [roles, setRoles] = React.useState([]);

    const getRoles = async () => {
        const response = await fetch('/api/account/role/list');
        const result = await response.json();

        if (result && result.success) {
            setRoles(result.data);
        }
    }

    React.useEffect(() => {
        getRoles();
    }, []);

    return (
        <div>
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                <NavItem href="/account/role-create" text="创建角色">
                    <FormOutlined style={iconStyle} />
                </NavItem>
            </Row>
            <h2>角色列表</h2>
            <List bordered>
                {
                    roles && roles.map((item, index) => {
                        const actions = [];
                        if (item.roleCode !== 'SUPER_ADMIN') {
                            actions.push(<a href={`/account/role-create?roleId=${item.roleId}`}>编辑</a>);
                        }
                        return <List.Item key={item.roleId}
                            actions={actions}
                        >
                            <div>{item.roleTitle}</div>
                        </List.Item>
                    })
                }
            </List>
            {
                (!roles || roles.length === 0) && <div style={{textAlign: 'center', padding: '20px 0'}}>暂无角色，<a href='/account/role-create'>创建角色</a></div>
            }
        </div>
    )
}